import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Button, Table } from 'semantic-ui-react';
import { translate } from 'react-i18next';

import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { fetchDirList, fetchFileList, download, upload } from '../../../data/fileImport/ftpActions';

class DownloadModal extends Component {

  constructor(props) {
    super(props);

    this.fetchFiles = this.fetchFiles.bind(this);

    this.state = {
      selectValue: 'default',
      downloadList: {},
      uploadList: {}
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchDirList());
  }

  setDownloadList(fileName, value) {
    this.setState(prevState => {
      return {
        ...prevState,
        downloadList: {
          ...prevState.downloadList,
          [fileName]: value
        }
      }
    });
  }

  setUploadList(fileName, value) {
    this.setState(prevState => {
      return {
        ...prevState,
        uploadList: {
          ...prevState.uploadList,
          [fileName]: value
        }
      }
    });
  }

  fetchFiles(event) {
    this.props.dispatch(fetchFileList(event.target.value));
    this.setState({selectValue: event.target.value});
  }

  download(fileName) {
    this.setDownloadList(fileName, true);
    this.props.dispatch(download(this.state.selectValue, fileName, this.setDownloadList.bind(this)));
  }

  upload(fileName) {
    if (!this.props.resources) return;
    this.setUploadList(fileName, true);
    const participation = this.props.resources.session.participations[0];
    this.props.dispatch(
      upload(this.state.selectValue,fileName, participation.id, this.props.resources.equipment.id, this.setUploadList.bind(this))
    );
  }

  render() {
    const options =
      this.props.directories.map(dir =>
        <option key={dir.name}>{dir.name}</option>
      );

    let table;
    if (this.props.files) {
      if (this.props.files.length > 0) {
        const list = this.props.files.map(file =>
          <Table.Row key={file.name.toString()}>
            <Table.Cell>{file.name}</Table.Cell>
            <Table.Cell>{this.props.t('data.size_kilobytes_display', {size : file.size / 1000})}</Table.Cell>
            <Table.Cell>{new Date(file.date).toLocaleString()}</Table.Cell>
            <Table.Cell>
              {this.state.downloadList[file.name]
                ? <p>{this.props.t('data.loading')}</p>
                : <Button onClick={() => this.download(file.name)}>{this.props.t('data.download')}</Button>
              }
            </Table.Cell>
            <Table.Cell>
              {this.state.uploadList[file.name]
                ? <p>{this.props.t('data.loading')}</p>
                : <Button color="blue" onClick={() => this.upload(file.name)}>{this.props.t('data.upload')}</Button>
              }
            </Table.Cell>
          </Table.Row>
        );
        table =
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{this.props.t('data.name')}</Table.HeaderCell>
                <Table.HeaderCell>{this.props.t('data.size')}</Table.HeaderCell>
                <Table.HeaderCell>{this.props.t('data.date_modified')}</Table.HeaderCell>
                <Table.HeaderCell> </Table.HeaderCell>
                <Table.HeaderCell> </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {list}
            </Table.Body>
          </Table>;
      } else {
        table = <p> {this.props.t('data.empty_directory_message')} </p>;
      }
    } else {
      table = <p> {this.props.t('data.fetching_data')} </p>
    }

    return (
      <PhotoBoothModal {...this.props}>
        <select onChange={this.fetchFiles} value={this.state.selectValue}>
          <option disabled value="default"> -- {this.props.t('data.select_directory_prompt')} -- </option>
          {options}
        </select>
        {table}
      </PhotoBoothModal>)
  }
}

export default connect(
  state => ({
    directories: state.projects.single.fileImport.ftpDirList,
    files: state.projects.single.fileImport.ftpFileList,
    resources: state.projects.single.fileImport.modals.downloadModal.resourceId
  })
)(translate()(DownloadModal))


// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/DownloadModal.js